"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Modal_1 = __importDefault(require("@mui/material/Modal"));
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const NestedQMenu = ({ open, width, header, options, onClose, anchorEl, onChange, currentHover, selectedOption, }) => {
    const { classes, theme } = useStyles();
    const [path, setPath] = (0, react_1.useState)([]);
    const [anchors, setAnchors] = (0, react_1.useState)([]);
    const [subNodes, setSubNodes] = (0, react_1.useState)([]);
    const [lastScrollTop, setLastScrollTop] = (0, react_1.useState)(0);
    const [headerHeight, setHeaderHeight] = (0, react_1.useState)(0);
    const scrollRefInternal = (0, react_1.useRef)([null]);
    const trackedOptions = (0, react_1.useRef)([]);
    const clearAllTracking = () => {
        if (path.length || anchors.length || subNodes.length) {
            setPath([]);
            setAnchors([]);
            setSubNodes([]);
        }
    };
    const closeMenus = (event = undefined) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (onClose) {
            onClose();
        }
        clearAllTracking();
        if (currentHover) {
            currentHover(null);
        }
    };
    const findOption = (optionsPassed, option, pathPassed = []) => {
        let pathFound;
        optionsPassed.forEach((optionItem) => {
            if (optionItem.value === option.value) {
                pathFound = [...pathPassed, optionItem];
            }
            else if (optionItem.subMenu && optionItem.subMenu.length) {
                pathFound = findOption(optionItem.subMenu, option, [...pathPassed, optionItem]);
            }
        });
        return pathFound;
    };
    const scrollRef = () => scrollRefInternal.current[path.length];
    const initMenu = (firstOrLast, offset = 0) => {
        if (!open)
            return;
        let pathGenerated;
        if (selectedOption) {
            pathGenerated = findOption(trackedOptions.current[0], selectedOption);
        }
        else if (firstOrLast === 'first') {
            const first = trackedOptions.current[0][0 + offset];
            if (first) {
                pathGenerated = [first];
                setTimeout(() => {
                    const scroll = scrollRef();
                    if (scroll && scroll.scrollTop) {
                        scroll.scrollTop = 0;
                    }
                }, 0);
            }
        }
        else if (firstOrLast === 'last') {
            const last = trackedOptions.current[0][trackedOptions.current[0].length - 1 + offset];
            pathGenerated = last ? [last] : undefined;
        }
        if (!pathGenerated || !pathGenerated.length)
            return;
        const option = pathGenerated[pathGenerated.length - 1];
        setPath(pathGenerated);
        setSubNodes(option && option.subMenu ? [option.subMenu] : []);
        setAnchors(option && option.subMenu ? [document.getElementById(`${option.menuIndex}${option.label}${option.menuDepth}`)] : []);
    };
    const pathContainsOption = (option) => path.some((crumb) => crumb.label === option.label
        && option.menuDepth === crumb.menuDepth && crumb.menuIndex === option.menuIndex);
    const handleOptionHover = (event, option) => {
        var _a;
        setLastScrollTop(((_a = scrollRef()) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0);
        const { menuDepth } = option;
        let clonedPath = path;
        let clonedAnchors = anchors;
        let clonedSubNodes = subNodes;
        if (menuDepth <= clonedPath.length) { // we need to backtrack
            clonedPath = clonedPath.slice(0, menuDepth).concat([option]); // always make the path end at the current hovered on
            clonedAnchors = clonedAnchors.slice(0, menuDepth);
            clonedSubNodes = subNodes.slice(0, menuDepth);
            if (option.subMenu) {
                clonedAnchors = clonedAnchors.concat([event.currentTarget]);
                clonedSubNodes = clonedSubNodes.concat([option.subMenu]);
            }
        }
        else if (option.subMenu) { // we need to add a new level
            clonedPath = clonedPath.concat([option]);
            clonedAnchors = option.subMenu ? clonedAnchors.concat([event.currentTarget]) : clonedAnchors;
            clonedSubNodes = option.subMenu ? clonedSubNodes.concat([option.subMenu]) : clonedSubNodes;
        }
        setPath(clonedPath);
        setAnchors(clonedAnchors);
        setSubNodes(clonedSubNodes);
    };
    const handleOptionClick = (_event, option) => {
        if (onChange && option.value) {
            onChange(option.value);
        }
        if (currentHover) {
            currentHover(null);
        }
    };
    const composeItems = (optionsPassed, depth = 0) => {
        if (!optionsPassed)
            return [];
        if (trackedOptions.current.length < depth + 1)
            trackedOptions.current.push([]);
        else
            trackedOptions.current[depth] = [];
        const items = [];
        optionsPassed.forEach((option, index) => {
            if (!option) {
                return;
            }
            if (option.isSubheader) {
                items.push(<ListItem_1.default key={`subtitle-${option.label}`} style={{ backgroundColor: option.backgroundColor || '' }} className={classes.subheader}>
            {option.startIcon &&
                        <ListItemIcon_1.default className={classes.startIcon}>
                  {option.startIcon}
                </ListItemIcon_1.default>}
            <QTypography_1.default variant="caption">
              {option.label}
            </QTypography_1.default>
          </ListItem_1.default>);
            }
            else if (option.isGroupList) {
                // TODO: add group lists into the menu
            }
            else if (!option.nop) { // regular items and ones with submenus
                const trackedOption = Object.assign(Object.assign({}, option), { menuDepth: depth, menuIndex: trackedOptions.current[depth].length });
                trackedOptions.current[depth].push(trackedOption);
                items.push(<ListItem_1.default id={option.id || `${trackedOptions.current[depth].length - 1}${option.label}${depth}`} 
                // eslint-disable-next-line react/no-array-index-key
                key={`qnested-menuitem-${index}${option.label}${depth}`} onMouseEnter={(event) => handleOptionHover(event, trackedOption)} onClick={option.onSelect ? option.onSelect : (event) => handleOptionClick(event, trackedOption)} className={classes.item} style={Object.assign({ 
                        // @ts-expect-error: Property 'level1' does not exist on type 'Color'.
                        backgroundColor: !pathContainsOption(trackedOption) ? option.backgroundColor || '' : theme.palette.grey.level1 }, (option.style ? option.style : {}))} sx={option.disabled ? { opacity: 0.5, pointerEvents: 'none', userSelect: 'none' } : null}>
            {option.customRender ?
                        option.customRender
                        :
                            <div className={classes.flexRow}>
                  {option.startIcon &&
                                    <ListItemIcon_1.default classes={{ root: classes.startIcon }}>
                        {option.startIcon}
                      </ListItemIcon_1.default>}
                  <div>
                    <QTypography_1.default>
                      {option.label}
                    </QTypography_1.default>
                    {option.subtext &&
                                    <QTypography_1.default variant="caption">
                          {option.subtext}
                        </QTypography_1.default>}
                  </div>
                </div>}
            {option.subMenu &&
                        <IconButton_1.default 
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        onClick={handleArrowClick} className={classes.rightArrowButton} size="large">
                  <KeyboardArrowRight_1.default className={classes.rightArrowStyles}/>
                </IconButton_1.default>}
          </ListItem_1.default>);
            }
            if (option.divider) {
                items.push(<Divider_1.default 
                // eslint-disable-next-line react/no-array-index-key
                key={`${index}divider${depth}`} className={classes.divider}/>);
            }
        });
        return items;
    };
    (0, react_1.useEffect)(() => {
        initMenu('first');
        composeItems(options, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);
    const getActiveDepth = () => path.length - 1;
    const handlePrimaryMenuScroll = () => {
        var _a, _b;
        if (path.length > 0 && Math.abs(lastScrollTop - (((_a = scrollRef()) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0)) > 50) {
            clearAllTracking();
            setLastScrollTop(((_b = scrollRef()) === null || _b === void 0 ? void 0 : _b.scrollTop) || 0);
        }
    };
    const getNextOption = (currentOption) => {
        if (currentOption.menuIndex >= trackedOptions.current[currentOption.menuDepth].length - 1) {
            if (scrollRef()) {
                scrollRef().scrollTop = 0;
            }
            return trackedOptions.current[currentOption.menuDepth][0]; // wraps back around to the beginning
        }
        return trackedOptions.current[currentOption.menuDepth][currentOption.menuIndex + 1];
    };
    const getPrevOption = (currentOption) => {
        if (currentOption.menuIndex <= 0) {
            if (scrollRef()) {
                scrollRef().scrollTop = scrollRef().scrollHeight;
            }
            return trackedOptions.current[currentOption.menuDepth][trackedOptions.current[currentOption.menuDepth].length - 1]; // wrap around to end
        }
        return trackedOptions.current[currentOption.menuDepth][currentOption.menuIndex - 1];
    };
    const handleKeyPress = (0, react_1.useCallback)((event) => {
        var _a;
        if (options.length === 0 || !open) {
            return;
        }
        // ################################## -- Enter -- ################################## //
        if (event.key === 'Enter') {
            const currentBoi = path[path.length - 1];
            if (!currentBoi) {
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            if (currentBoi.onSelect) {
                currentBoi.onSelect();
            }
            else {
                handleOptionClick(event, path[path.length - 1]);
            }
        }
        else if (event.key === 'Tab' || event.key === 'Escape') {
            // ################################## -- Tab -- ################################## //
            closeMenus();
        }
        else if (['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(event.key)) {
            if (path.length === 0) {
                if (event.key === 'ArrowDown') {
                    initMenu('first');
                }
                else if (event.key === 'ArrowUp') {
                    if (scrollRef()) {
                        scrollRef().scrollTop = scrollRef().scrollHeight;
                    }
                    initMenu('last');
                }
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            if ((event.key === 'ArrowRight' && path[path.length - 1].subMenu)
                || (event.key === 'ArrowLeft' && path.length > 1)) { // if it's moving the menu don't move the cursor
            }
            let clonedPath = path;
            let clonedAnchors = anchors;
            let clonedSubNodes = subNodes;
            const currentOption = clonedPath[clonedPath.length - 1];
            // ################################## -- ArrowRight -- ################################## //
            if (event.key === 'ArrowRight' && clonedPath[clonedPath.length - 1].subMenu) {
                const trackedOptionsClone = (_a = trackedOptions.current[getActiveDepth() + 1]) === null || _a === void 0 ? void 0 : _a[0];
                if (trackedOptionsClone) {
                    clonedPath = clonedPath.concat([trackedOptionsClone]); // add the first of the subMenu to the path
                }
                if (clonedPath && clonedPath[clonedPath.length - 1].subMenu) { // if moving right leads to another subMenu
                    const { menuIndex, menuDepth, label } = clonedPath[clonedPath.length - 1];
                    clonedAnchors = clonedAnchors.concat([document.getElementById(`${menuIndex}${label}${menuDepth}`)]);
                    // @ts-expect-error: No overload matches this call.
                    clonedSubNodes = clonedSubNodes.concat([clonedPath[clonedPath.length - 1].subMenu]);
                }
            }
            else if (event.key === 'ArrowDown') {
                // ################################## -- ArrowDown -- ################################## //
                const { menuIndex, menuDepth, label } = clonedPath[clonedPath.length - 1];
                const child = document.getElementById(`${menuIndex}${label}${menuDepth}`);
                const scroller = scrollRef();
                if (scroller && child && child.offsetTop + (2 * child.offsetHeight) >= scroller.offsetHeight + scroller.scrollTop) {
                    scroller.scrollTop += child.offsetHeight;
                }
                handlePrimaryMenuScroll();
                const nextOption = getNextOption(clonedPath[clonedPath.length - 1]);
                clonedPath = clonedPath.slice(0, clonedPath.length - 1).concat([nextOption]);
                if (currentOption.subMenu) {
                    clonedAnchors = clonedAnchors.slice(0, clonedAnchors.length - 1);
                    clonedSubNodes = clonedSubNodes.slice(0, clonedSubNodes.length - 1);
                }
                if (nextOption.subMenu) {
                    const nextId = `${nextOption.menuIndex}${nextOption.label}${nextOption.menuDepth}`;
                    clonedAnchors = clonedAnchors.concat([document.getElementById(nextId)]);
                    clonedSubNodes = clonedSubNodes.concat([nextOption.subMenu]);
                }
                event.preventDefault();
                event.stopPropagation();
            }
            else if (event.key === 'ArrowUp') {
                // ################################## -- ArrowUp -- ################################## //
                const { menuDepth, menuIndex, label } = clonedPath[clonedPath.length - 1];
                const child = document.getElementById(`${menuIndex}${label}${menuDepth}`);
                if (scrollRef() && child && child.offsetTop - child.offsetHeight <= scrollRef().scrollTop) {
                    scrollRef().scrollTop -= child.offsetHeight;
                }
                handlePrimaryMenuScroll();
                const prevOption = getPrevOption(clonedPath[clonedPath.length - 1]);
                clonedPath = clonedPath.slice(0, clonedPath.length - 1).concat([prevOption]);
                if (currentOption.subMenu) {
                    clonedAnchors = clonedAnchors.slice(0, clonedAnchors.length - 1);
                    clonedSubNodes = clonedSubNodes.slice(0, clonedSubNodes.length - 1);
                }
                if (prevOption && prevOption.subMenu) {
                    const prevId = `${prevOption.menuIndex}${prevOption.label}${prevOption.menuDepth}`;
                    clonedAnchors = clonedAnchors.concat([document.getElementById(prevId)]);
                    clonedSubNodes = clonedSubNodes.concat([prevOption.subMenu]);
                }
                event.preventDefault();
                event.stopPropagation();
            }
            else if (event.key === 'ArrowLeft') {
                // ################################## -- ArrowLeft -- ################################## //
                clonedPath = clonedPath.length > 1 ? clonedPath.slice(0, clonedPath.length - 1) : clonedPath;
                if (clonedPath.length < clonedAnchors.length) {
                    clonedAnchors = clonedAnchors.slice(0, clonedAnchors.length - 1);
                    clonedSubNodes = clonedSubNodes.slice(0, clonedSubNodes.length - 1);
                }
            }
            setPath(clonedPath);
            setAnchors(clonedAnchors);
            setSubNodes(clonedSubNodes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, open, options, anchors, subNodes]);
    const handleArrowClick = (event) => {
        handleKeyPress({
            key: 'ArrowRight',
            stopPropagation: () => 0,
            preventDefault: () => 0,
        });
        event.stopPropagation();
    };
    (0, react_1.useEffect)(() => {
        if (!open) {
            document.removeEventListener('keydown', handleKeyPress, { capture: true });
            clearAllTracking();
        }
        else {
            document.addEventListener('keydown', handleKeyPress, { capture: true });
        }
        return () => {
            document.removeEventListener('keydown', handleKeyPress, { capture: true });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, handleKeyPress]);
    const getAnchor = () => anchorEl || null;
    if (!anchorEl || !options)
        return <div />;
    const spaceBelow = window.innerHeight - anchorEl.getBoundingClientRect().top - 80;
    const spaceAbove = anchorEl.getBoundingClientRect().top - 80;
    const rootPlacement = spaceAbove > spaceBelow ? 'top' : 'bottom';
    const rootHeight = (spaceAbove > spaceBelow ? spaceAbove : spaceBelow) - headerHeight; // 80 for spacing
    const menuItems = composeItems(options, 0);
    // callback to let parent know if the user is navigating through the menu
    if (currentHover) {
        if (path.length > 0 && open) {
            currentHover(path[path.length - 1]);
        }
        else {
            currentHover(null);
        }
    }
    const filteredAnchors = anchors.filter((anchorItem) => anchorItem);
    const setHeaderRef = (ref) => {
        if (ref) {
            const headerHeightGenerated = ref.getBoundingClientRect().bottom - ref.getBoundingClientRect().top;
            setHeaderHeight(headerHeightGenerated);
        }
    };
    const setScrollRef = (node) => {
        const depth = path.length;
        scrollRefInternal.current[depth] = node;
    };
    return (<Modal_1.default className={classes.root} open={open} 
    // @ts-expect-error: 'onBackdropClick' is deprecated.
    onBackdropClick={closeMenus} BackdropProps={{
            style: {
                backgroundColor: 'transparent',
            },
        }}>
      <>
        <Popper_1.default id="picker-boi" key="picker-boi" open anchorEl={getAnchor()} placement={rootPlacement} className={menuItems.length > 0 ? (0, classnames_1.default)(classes.popper, classes.rootPopper) : ''} style={{
            width: width || anchorEl.offsetWidth,
        }} modifiers={[{
                name: 'flip',
                options: {
                    fallbackPlacements: ['right', 'left', 'bottom', 'top'],
                },
            }]}>
          <div key="headerDiv==" ref={setHeaderRef}>
            {header}
          </div>
          <div id="top-wrapper-qnested-menu" className={classes.primaryMenu} style={{
            maxHeight: rootHeight - 40,
        }} ref={(node) => {
            if (path.length <= 1) {
                setScrollRef(node);
            }
        }}>
            {menuItems.map((menuItem) => menuItem)}
          </div>
        </Popper_1.default>
        {open && filteredAnchors.length > 0 && filteredAnchors.map((anchor, index) => {
            var _a;
            const label = (_a = path[index]) === null || _a === void 0 ? void 0 : _a.label;
            const popperId = `qnested-popper-menu-item-${label}`;
            const id = `qnested-menu-item-${label}`;
            return (<Popper_1.default id={popperId} key={popperId} open anchorEl={anchor} className={classes.popper} placement="right">
              <div id={id} className={classes.secondaryMenu} ref={(node) => {
                    if (path.length > 1 && index === anchors.length - 1) {
                        setScrollRef(node);
                    }
                }}>
                {composeItems(subNodes[index], index + 1).map((nodeItem) => nodeItem)}
              </div>
            </Popper_1.default>);
        })}
      </>
    </Modal_1.default>);
};
exports.default = (0, react_1.memo)(NestedQMenu);
